import { render, staticRenderFns } from "./CoverImg.vue?vue&type=template&id=3c48dbd1&scoped=true&"
import script from "./CoverImg.vue?vue&type=script&lang=js&"
export * from "./CoverImg.vue?vue&type=script&lang=js&"
import style0 from "./CoverImg.vue?vue&type=style&index=0&id=3c48dbd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c48dbd1",
  null
  
)

export default component.exports